import React from 'react';

const Footer = () => {
  return (
    <footer className="relative bg-gray-800 text-white py-12 overflow-hidden">
      {/* Background Logo Images - Large and Centered */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="relative w-full h-full flex items-center justify-center">
          {/* Cow logo - Left side */}
          <img 
            src="/images/cow_logo.jpg" 
            alt="Cow logo background" 
            className="absolute left-8 md:left-16 top-1/2 transform -translate-y-1/2 h-32 md:h-48 lg:h-64 w-auto object-contain opacity-10 hover:opacity-20 transition-opacity duration-500"
            onError={(e) => {e.target.style.display = 'none'}}
          />
          
          {/* Lobster logo - Right side - Flipped to face cow */}
          <img 
            src="/images/lobster_logo_light.jpg" 
            alt="Lobster logo background" 
            className="absolute right-8 md:right-16 top-1/2 transform -translate-y-1/2 scale-x-[-1] h-32 md:h-48 lg:h-64 w-auto object-contain opacity-10 hover:opacity-20 transition-opacity duration-500"
            onError={(e) => {e.target.style.display = 'none'}}
          />
        </div>
      </div>

      {/* Content - Positioned above background images with higher z-index */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        <h3 className="text-3xl font-bold text-red-600 mb-4">Nou Valentino</h3>
        <p className="text-gray-300 mb-6">Cocina Tradicional Francesa y Belga • Elaboración Casera • Amplia Variedad de Postres Artesanales</p>
        
        {/* Additional centered logos - smaller versions for visual interest */}
        <div className="flex justify-center items-center gap-8 mb-6">
          <img 
            src="/images/cow_logo.jpg" 
            alt="Cow logo" 
            className="h-12 md:h-16 w-auto object-contain opacity-60 hover:opacity-80 transition-opacity duration-300"
            onError={(e) => {e.target.style.display = 'none'}}
          />
          <div className="w-px h-12 bg-red-600/30"></div>
          <img 
            src="/images/lobste_logo.jpg" 
            alt="Lobster logo" 
            className="h-12 md:h-16 w-auto object-contain opacity-60 hover:opacity-80 transition-opacity duration-300"
            onError={(e) => {e.target.style.display = 'none'}}
          />
        </div>
        
        <div className="flex justify-center gap-8 text-sm">
          <span>© 2025 Nou Valentino</span>
          <span>•</span>
          <span>Todos los Derechos Reservados</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;